var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNeedInfosIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon info",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42.001,
    viewBox: "0 0 42 42.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 .001)",
    style: {
      fill: "none"
    },
    d: "M0 0h42v42H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16220-293a21 21 0 0 1 21-21 21 21 0 0 1 21 21 21 21 0 0 1-21 21 21 21 0 0 1-21-21zm13.215-18.431a20.038 20.038 0 0 0-6.358 4.289 19.947 19.947 0 0 0-4.285 6.354A19.84 19.84 0 0 0 16221-293a19.835 19.835 0 0 0 1.571 7.783 19.919 19.919 0 0 0 4.285 6.359 19.959 19.959 0 0 0 6.358 4.285A19.84 19.84 0 0 0 16241-273a19.835 19.835 0 0 0 7.783-1.571 19.959 19.959 0 0 0 6.358-4.285 19.919 19.919 0 0 0 4.285-6.359A19.835 19.835 0 0 0 16261-293a19.84 19.84 0 0 0-1.571-7.787 19.947 19.947 0 0 0-4.285-6.354 20.038 20.038 0 0 0-6.358-4.289A19.909 19.909 0 0 0 16241-313a19.913 19.913 0 0 0-7.785 1.57z",
    transform: "translate(-16220 314.001)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16238-284.559h3.191l1.159-11.023h-3.187zm1.114-14.276a1.743 1.743 0 0 0 1.849 1.751 2.151 2.151 0 0 0 2.184-2.163 1.739 1.739 0 0 0-1.847-1.753 2.158 2.158 0 0 0-2.188 2.165z",
    transform: "translate(-16220 314.001)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16230.395-282.392A14.909 14.909 0 0 1 16226-293a14.9 14.9 0 0 1 4.4-10.6 14.907 14.907 0 0 1 10.6-4.4 14.9 14.9 0 0 1 10.6 4.4 14.9 14.9 0 0 1 4.4 10.6 14.909 14.909 0 0 1-4.4 10.611 14.9 14.9 0 0 1-10.6 4.4 14.907 14.907 0 0 1-10.605-4.403z",
    style: {
      stroke: "none"
    },
    transform: "translate(-16220 314.001)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16241.002-278.997a13.91 13.91 0 0 0 9.896-4.102 13.916 13.916 0 0 0 4.103-9.904c0-3.736-1.457-7.25-4.103-9.896a13.909 13.909 0 0 0-9.896-4.103 13.913 13.913 0 0 0-9.9 4.103 13.907 13.907 0 0 0-4.103 9.896c0 3.74 1.457 7.258 4.103 9.904a13.913 13.913 0 0 0 9.9 4.102m0 1a14.907 14.907 0 0 1-10.607-4.395 14.909 14.909 0 0 1-4.396-10.611c0-4.004 1.564-7.771 4.396-10.603a14.907 14.907 0 0 1 10.607-4.396c4.008 0 7.77 1.563 10.603 4.396a14.904 14.904 0 0 1 4.396 10.603c0 4.011-1.564 7.778-4.396 10.61a14.898 14.898 0 0 1-10.603 4.396z",
    fill: "currentColor",
    transform: "translate(-16220 314.001)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedInfosIcon);
export default __webpack_public_path__ + "static/media/need-infos-icon.cf29331d5d380bd8735026ed4c5bd927.svg";
export { ForwardRef as ReactComponent };